<template>
    <banner-cta v-if="!isUserImpersonating" class="hidden-print">
        <div slot="icon">
            <i class="icons8-bell"/>
        </div>
        <div slot="text">
            <p>{{$t('components.for-security-purposes-space-owners-are-encouraged-to-verify-their-email-address')}}</p>
        </div>
        <div slot="button">
            <a :href="redirectToVerifyEmail" class="btn btn-dark">{{$t('components.verify-email-address')}}</a>
        </div>
    </banner-cta>
</template>

<script>
    import BannerCta from './BannerCTA';
    import { getViewData } from '../../modules/view-data';

    export default {
        name: 'email-verification-banner',

        components: { BannerCta },

        computed: {
            redirectToVerifyEmail() {
                return this.$laroute.route('account.landlord.trust');
            },

            isUserImpersonating() {
                return getViewData('user.impersonating');
            },
        },
    };
</script>
